import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useHotkeysNav() {
  const navigate = useNavigate();

  useEffect(() => {
    const onKeyDown = (e) => {
      const tag = (e.target && e.target.tagName) || '';
      const isTyping =
        tag === 'INPUT' || tag === 'TEXTAREA' || e.target?.isContentEditable;
      if (isTyping) return;

      const key = e.key;

      const alt = e.altKey && !e.ctrlKey && !e.metaKey;
      const ctrlAlt = e.altKey && e.ctrlKey && !e.metaKey;

      if (!alt && !ctrlAlt) return;

      if (key === '1') {
        e.preventDefault();
        navigate('/dashboard');
      }
      if (key === '2') {
        e.preventDefault();
        navigate('/transactions');
      }
      if (key === '3') {
        e.preventDefault();
        navigate('/goals');
      }
      if (key === '4') {
        e.preventDefault();
        navigate('/settings');
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [navigate]);
}
